module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "qr"
  }, [_c('v-qr-code', {
    staticClass: "code",
    attrs: {
      "qrString": _vm.qrString,
      "title": "我的取餐码",
      "status": ""
    }
  })], 1), _vm._v(" "), _c('v-button', {
    staticClass: "button",
    attrs: {
      "text": "返回",
      "primary": ""
    },
    on: {
      "click": function($event) {
        _vm.$router.back()
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d1c8167c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pg/my-qr-code.vue
// module id = 889
// module chunks = 34